<template>
  <div>
    <b-field grouped v-if="inline">
      <b-field
        label="Desde"
        label-position="inside">
        <b-datepicker
            placeholder="Desde"
            icon="calendar-today"
            position="is-bottom-left"
            :first-day-of-week="1"
            :month-names="$moment.months()"
            :day-names="$moment.weekdaysShort()"
            v-model="start"
            :max-date="finish"
            @input="setFrom"
            >
        </b-datepicker>
      </b-field>
      <b-field
        label="Hasta"
        label-position="inside">
        <b-datepicker
          placeholder="Hasta"
          icon="calendar-today"
          position="is-bottom-left"
          :first-day-of-week="1"
          :month-names="$moment.months()"
          :day-names="$moment.weekdaysShort()"
          v-model="finish"
          :min-date="start"
          @input="setTo"
          >
        </b-datepicker>
      </b-field>
    </b-field>
    <div v-else>
      <b-field
        label="Desde"
        label-position="inside">
        <b-datepicker
            placeholder="Desde"
            icon="calendar-today"
            position="is-bottom-left"
            :first-day-of-week="1"
            :month-names="$moment.months()"
            :day-names="$moment.weekdaysShort()"
            v-model="start"
            :max-date="finish"
            @input="setFrom"
            >
        </b-datepicker>
      </b-field>
      <b-field
        label="Hasta"
        label-position="inside">
        <b-datepicker
          placeholder="Hasta"
          icon="calendar-today"
          position="is-bottom-left"
          :first-day-of-week="1"
          :month-names="$moment.months()"
          :day-names="$moment.weekdaysShort()"
          v-model="finish"
          :min-date="start"
          @input="setTo"
          >
        </b-datepicker>
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inline: {
      type: Boolean,
      default: true,
      required: false
    },
    from: {
      required: false,
      default: () => new Date()
    },
    to: {
      required: false,
      default: () => new Date()
    }
  },
  data () {
    return {
      start: this.from,
      finish: this.to
    }
  },
  methods: {
    setFrom (date) {
      this.$emit('update:from', date)
    },
    setTo (date) {
      this.$emit('update:to', date)
    }
  },
  watch: {
    from () {
      if (this.from !== this.start) {
        this.start = this.from
      }
    },
    to () {
      if (this.to !== this.finish) {
        this.finish = this.to
      }
    }
  }
}
</script>

<style>
  /* .dpk-range-input input{
    background-color: #FF9800;
    border:0;
    color: white;
    cursor: pointer;
  }
  .dpk-range-input  > .control  .dropdown-trigger .control.has-icons-left.is-clearfix .icon{
    color: white !important;
    opacity: 1;
  }

  .dpk-range-input input::placeholder{
    color: white;
    opacity: 1;
  }

  .dpk-range-input > .control:first-child  .dropdown-trigger .control.has-icons-left.is-clearfix, .dpk-range-input > .control:first-child input{
    border-right:1px solid #424242 !important;
  } */
</style>
